// src/api/index.js
const backendDomain = "http://192.168.1.144/oakya_official";
// const backendDomain = "https://your-production-domain.com/oakya_official"; // For production

const EmailApi = {
  SendMail: {
    url: `${backendDomain}/mail/sendmail.php`,
    method: "POST"
  }
};

export default EmailApi;